import { SalesDashboardChartProps, SalesDashboardChartSeries } from '../components/sales-dashboard-chart/types.ts'
import { CUSTOMER_TYPES } from '@boltenergy-be/shared'
import { DSChartColors } from 'types/colors.ts'

const CLIENT_TYPE_SERIES: SalesDashboardChartSeries[] = [
  { key: CUSTOMER_TYPES.residential, label: CUSTOMER_TYPES.residential, color: DSChartColors.PURPLE },
  { key: CUSTOMER_TYPES.professional, label: CUSTOMER_TYPES.professional, color: DSChartColors.DARK }
]

export const SALES_CHART_DEFAULT_PROPS: Pick<SalesDashboardChartProps, 'series' | 'legendTitle' | 'xAxisLabel' | 'yAxisLabel'> = {
  series: CLIENT_TYPE_SERIES,
  legendTitle: 'Client type',
  xAxisLabel: 'Close date',
  yAxisLabel: 'Record Count'
}

const BASE_TABLE_COLUMNS = [
  { key: 'date', header: 'Close date' },
  { key: 'agent', header: 'Agent' }
]

export const COUNT_TABLE_COLUMNS = [...BASE_TABLE_COLUMNS, { key: 'count', header: 'Record count' }]
export const RATE_TABLE_COLUMNS = [...BASE_TABLE_COLUMNS, { key: 'rate', header: 'Rate' }]
